define(['services/validators', 'services/converters', 'common/parameterApplications'],
    function(validators, converters, parameterApplications) {
        return {
            create: function() {
                return {
                    key: {validator: validators.string},
                    query: {validator: validators.string, required: true, application: parameterApplications.PATH},

                    /**
                    * @class Geocode
                    * @module Services
                    */

                    
                    /**
                     * Sets or returns the value of the `storeResult` option.
                     *
                     * If this option is enabled the query will be interpreted as a stored geocode and will be billed
                     * according to the terms of use.
                     *
                     * @method storeResult
                     * @deprecated Announcement date: 1st December 2017. The previous version will be deprecated and taken off-line 1 year after the announcement. Deprecation date: 1st December 2018.
                     * @chainable
                     * @param {Boolean} [newValue] Enable or disable the option
                     * @throws {TypeError} if the given argument cannot be converted into a valid value
                     * @return {Boolean} The same service instance or the current option value if no argument was given
                     */
                    
                    storeResult: {validator: validators.bool},
                    typeahead: {validator: validators.bool},
                    limit: {validator: validators.positiveInteger},
                    offset: {validator: validators.naturalInteger, name: 'ofs'},
                    language: {validator: validators.languageCode},
                    boundingBox: {validator: validators.boundingBox, converter: converters.boundingBox},
                    center: {converter: converters.point, validator: validators.point},
                    countrySet: {validator: validators.countrySet},
                    radius: {validator: validators.naturalInteger},
                    bestResult: {validator: validators.bool},
                    protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')},
                    unwrapBbox: {validator: validators.bool, defaultValue: false, required: true}
                };
            },
            modifyRequestOptions: function(data) {
                var bestResult = Boolean(data.bestResult);
                if (bestResult) {
                    data.limit = 1;
                    data.offset = 0;
                }

                if (data.center) {
                    data.center = data.center.split(',');
                    data.lat = data.center[0];
                    data.lon = data.center[1];
                    delete data.center;
                }
            },
            modifyFields: function(fields) {
                var resultFields = Object.assign({}, fields);
                if (resultFields.boundingBox) {
                    resultFields.topLeft = {};
                    resultFields.btmRight = {};
                    delete resultFields.boundingBox;
                }

                if (resultFields.center) {
                    resultFields.lat = {};
                    resultFields.lon = {};
                    delete resultFields.center;
                }
                return resultFields;
            }
        };

    });



// WEBPACK FOOTER //
// ./services/geocode/geocodeParameters.js